/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "InertialManager", {
  enumerable: true,
  get: function get() {
    return _InertialManager.default;
  }
});
exports.default = void 0;
var _src = _interopRequireDefault(require("./src"));
var _InertialManager = _interopRequireDefault(require("./src/InertialManager"));
var _default = _src.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/InertialScroller/index.js
// module id = 688
// module chunks = 0